import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import ItemList from 'flarum/common/utils/ItemList';
import extractText from 'flarum/common/utils/extractText';
import PollListState from '../states/PollListState';
import PollShowcase from './Poll/PollShowcase';
import PollPageHero from './PollPageHero';
import PollsIndexSidebar from './PollsIndexSidebar';
export default class PollsShowcasePage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", void 0);
    _defineProperty(this, "endedState", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    if (!app.forum.attribute('globalPollsEnabled')) {
      m.route.set('/');
      return;
    }
    this.state = new PollListState({
      sort: m.route.param('sort'),
      filter: {
        '-isEnded': '1',
        isDraft: '0'
      },
      include: this.includeParams()
    });
    this.endedState = new PollListState({
      sort: m.route.param('sort'),
      filter: {
        isEnded: '1',
        isDraft: '0'
      },
      include: this.includeParams()
    });
    this.state.refresh();
    this.endedState.refresh();
    app.setTitle(extractText(app.translator.trans('fof-polls.forum.page.nav')));
  }
  includeParams() {
    return ['options', 'votes', 'myVotes', 'myVotes.option'];
  }
  view() {
    return m(PageStructure, {
      className: "PollsShowcasePage",
      hero: this.hero.bind(this),
      sidebar: this.sidebar.bind(this),
      loading: !this.state
    }, this.contentItems().toArray());
  }
  hero() {
    return m(PollPageHero, null);
  }
  sidebar() {
    return m(PollsIndexSidebar, null);
  }
  contentItems() {
    const items = new ItemList();
    items.add('poll-showcase', m(PollShowcase, {
      activeState: this.state,
      endedState: this.endedState
    }));
    return items;
  }
}
flarum.reg.add('fof-polls', 'forum/components/PollsShowcasePage', PollsShowcasePage);